import { HeadingPages } from '../../../components/HeadingPages'
import { Card } from './Card'
import { Box, Flex } from '@chakra-ui/layout'
import {
  ListaRankingMesSelect,
  ListaVendedoresAtivos,
} from '../../../services/api'
import React, { useEffect, useState } from 'react'
import { Button, Text, keyframes } from '@chakra-ui/react'
import { RankingStar } from './styles'
import axios from 'axios'
import { Select } from '@chakra-ui/select'

export function RankingVendedores() {
  const defaultMonth = new Date().getMonth() + 1
  const defaultMonthString = defaultMonth.toString().padStart(2, '0')
  const defaultYearString = new Date().getFullYear().toString()
  const [concatRanking, setConcatRanking] = useState([])
  const [rankingPed, setRankingPed] = useState([])
  const [month, setMonth] = useState(defaultMonthString)
  const [year, setYear] = useState(defaultYearString)
  const [yearSelect, setYearSelect] = useState('')
  const [loading, setLoading] = useState(false)

  const loadingAnimationPulse = keyframes`
    0% {
        opacity: 0.4;
      
    }
    100% {
        opacity: 1;
    }
  `

  async function ListaRankingEVendedores() {
    setLoading(true)
    const [responseRanking, responseVendedores] = await axios.all([
      ListaRankingMesSelect.get(`/${month.toString()}/${year.toString()}`),
      ListaVendedoresAtivos.get(),
    ])

    const arrayConcatRanking = responseRanking.data
      .map((item) => {
        const filterRanking = responseRanking.data.find(
          (itemFilter) => itemFilter.codigo_usuario === item.codigo_usuario
        )

        const filterVendedor = responseVendedores.data.find(
          (itemFilter) => itemFilter.codigo_usuario === item.codigo_usuario
        )

        return {
          ...item,
          valor_vendas_mes: filterRanking.valor_vendas_mes,
          vendedor: filterVendedor,
        }
      })
      .filter((item) => item.vendedor !== undefined)

    const arrayConcatPed = responseRanking.data
      .map((item) => {
        const filterRanking = responseRanking.data.find(
          (itemFilter) => itemFilter.codigo_usuario === item.codigo_usuario
        )
        const filterVendedor = responseVendedores.data.find(
          (itemFilter) => itemFilter.codigo_usuario === item.codigo_usuario
        )

        return {
          ...item,
          valor_vendas_mes: filterRanking.valor_vendas_mes,
          vendedor: filterVendedor,
        }
      })
      .filter((item) => item.vendedor !== undefined)

    const rankingOrderPed = arrayConcatPed.sort((a, b) => {
      if (parseInt(a.ranking_pedidos_mes) < parseInt(b.ranking_pedidos_mes)) {
        return -1
      }
      if (parseInt(a.ranking_pedidos_mes) > parseInt(b.ranking_pedidos_mes)) {
        return 1
      }

      return 0
    })

    console.log(arrayConcatRanking)

    setConcatRanking(arrayConcatRanking)
    setRankingPed(rankingOrderPed)
    setLoading(false)
  }

  useEffect(() => {
    ListaRankingEVendedores()
  }, [])

  const objectMonth = {
    1: 'Janeiro',
    2: 'Fevereiro',
    3: 'Março',
    4: 'Abril',
    5: 'Maio',
    6: 'Junho',
    7: 'Julho',
    8: 'Agosto',
    9: 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro',
  }

  useEffect(() => {
    objectYearsAndMonthDinamic()
  }, [])

  const objectYearsAndMonthDinamic = () => {
    const date = new Date()
    const year = date.getFullYear()
    const years = []

    for (let i = 2019; i <= year; i++) {
      years.push(i.toString())
    }

    setYearSelect(years)
    return years
  }

  function handleSubmit() {
    const params = {
      month: month < 10 ? `0${month}` : month,
      year,
    }
    ListaRankingEVendedores()
    console.log(params)
  }

  const date = new Date()
  const yearNow = date.getFullYear()
  const years = []

  for (let i = 2019; i <= yearNow; i++) {
    years.push(i.toString())
  }

  return (
    <>
      <HeadingPages name="Ranking de Vendedores" />

      <Box w="100%" maxW="1330px" mx="auto" mt={'2rem'} flexDir={'column'}>
        <Flex
          alignItems={'center'}
          justifyContent={'center'}
          maxW={'444px'}
          mx={'auto'}
          pb={'2rem'}
          gap={2}
        >
          <Select
            name={'month'}
            onChange={(e) => setMonth(e.target.value)}
            defaultValue={defaultMonthString}
          >
            <option value={''}>Mês</option>
            {Array.from({ length: 12 }, (_, i) => i + 1).map((item, index) => (
              <option key={index} value={item < 10 ? `0${item}` : item}>
                {objectMonth[item]}
              </option>
            ))}
          </Select>
          <Select
            name={'year'}
            onChange={(e) => setYear(e.target.value)}
            defaultValue={defaultYearString}
          >
            <option value={''}>Ano</option>
            {years?.map(
              (item, index) => (
                (
                  <option key={index} value={item}>
                    {item}
                  </option>
                )
              )
            )}
          </Select>

          <Button bg={'#378BBF'} color={'#fff'} onClick={handleSubmit}>
            Buscar
          </Button>
        </Flex>
        <Flex
          display={'flex'}
          alignItems={'flex-start'}
          justifyContent={'center'}
          gap={'3rem'}
          animation={
            loading ? `${loadingAnimationPulse} 2s linear infinite` : 'none'
          }
        >
          <Flex gap={'1.5rem'} w={'100%'} justifyContent={'center'}>
            <Flex
              flexDir={'column'}
              alignItems={'flex-start'}
              paddingBlock={'16px'}
              mt={'5.1rem'}
            >
              <Text
                bg={'#378BBF'}
                paddingBlock={'11px'}
                paddingInline={'32px'}
                color={'#fff'}
                width={'100%'}
                mb={2}
                maxW={'544px'}
                fontSize={'.9rem'}
              >
                Vendedores
              </Text>
              {concatRanking?.map((item, index) => {
                if (item.codigo_usuario !== '0') {
                  return (
                    <Flex
                      width={'100%'}
                      maxW={'544px'}
                      key={index}
                      alignItems={'center'}
                      justifyContent={'space-between'}
                      bg={index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'}
                      paddingBlock={'4px'}
                      paddingInline={'.5rem'}
                      position={'relative'}
                    >
                      <RankingStar index={parseInt(item.ranking_vendas_mes)} />
                      <Text>{item?.vendedor?.nome_vendedor}</Text>
                    </Flex>
                  )
                }
              })}
            </Flex>
            <Card
              title={'Vendas Acumuladas'}
              rankingList={concatRanking}
              numTrophies
            />
          </Flex>
          <Flex gap={'1.5rem'} w={'100%'} justifyContent={'center'}>
            <Flex
              flexDir={'column'}
              alignItems={'flex-start'}
              paddingBlock={'16px'}
              mt={'5.1rem'}
            >
              <Text
                bg={'#378BBF'}
                paddingBlock={'11px'}
                paddingInline={'32px'}
                color={'#fff'}
                width={'100%'}
                mb={2}
                maxW={'544px'}
                fontSize={'.9rem'}
              >
                Vendedores
              </Text>
              {rankingPed?.map((item, index) => {
                if (item.codigo_usuario !== '0') {
                  return (
                    <Flex
                      width={'100%'}
                      maxW={'544px'}
                      key={index}
                      alignItems={'center'}
                      justifyContent={'space-between'}
                      bg={index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'}
                      paddingBlock={'4px'}
                      paddingInline={'.5rem'}
                      position={'relative'}
                    >
                      <RankingStar index={parseInt(item.ranking_pedidos_mes)} />
                      <Text>{item?.vendedor?.nome_vendedor}</Text>
                    </Flex>
                  )
                }
              })}
            </Flex>
            <Card
              title={'Pedidos Acumulados'}
              rankingList={rankingPed}
              pedidos
            />
          </Flex>
        </Flex>
      </Box>
    </>
  )
}
